class ReviewSection extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Review-section-"]');
    this.next = this.querySelector('[id^="Review-next-"]');
    this.prev = this.querySelector('[id^="Review-prev-"]');
    this.pagination = this.querySelector('[id^="Review-pagination-"]');

    if (!this.slider) return;
    this.initPages();
  }
  initPages() {
    this.swiperOptions = {
      slidesPerView: 1.1,
      spaceBetween: 10,
      loop: false,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1366: {
          slidesPerView: 4,
          spaceBetween: 24,
        }
      },
    };

    if (!!this.next && !!this.prev) {
      this.swiperOptions.navigation = {
        enabled: true,
        nextEl: this.next,
        prevEl: this.prev
      }
    };

    if (!!this.pagination) {
      this.swiperOptions.pagination = {
        el: this.pagination,
        clickable: true,
      }
    }

    this.swiper = new Swiper(this.slider, this.swiperOptions);
  }

}
customElements.define('review-section', ReviewSection);